import request from '@/utils/request';
// 系统设置

//区域树结构
export const getAreaTree = () => {
    return request({
        url: '/api/eduRegion/tree',
        method: 'get',
    });
};
// 文章管理----------------------------------------
//文章管理列表
export const getArticleList = params => {
    return request({
        url: '/api/article/getPageList',
        method: 'post',
        data:params
    });
};
//文章栏目树结构
export const getArticleTree = () => {
    return request({
        url: '/api/eduArticleColumn/tree',
        method: 'get',
    });
};
//文章管理详情
export const getArticleDetail = (id) => {
    return request({
        url: `/eduArticle/info/${id}`,
        method: 'get',
    });
};
//删除文章
export const deleteArticle = params => {
    return request({
        url: '/eduArticle/delete',
        method: 'post',
        data:params
    });
};
//添加文章
export const addArticle = params => {
    return request({
        url:'/eduArticle/add',
        method: 'post',
        data:params
    });
};
//修改文章
export const updateArticle = params => {
    return request({
        url:'/eduArticle/update',
        method: 'post',
        data:params
    });
};
//批量修改文章栏目
export const updateArticleColumn = params => {
    return request({
        url:'/eduArticle/updateArticleColumn',
        method: 'post',
        data:params
    });
};
// 区域管理----------------------------------------
//区域管理列表
export const getAreaList = params => {
    return request({
        url: '/api/eduRegion/getPageList',
        method: 'post',
        data:params
    });
};
//区域管理详情
export const getAreaDetail = (id) => {
    return request({
        url: `/eduRegion/info/${id}`,
        method: 'get',
    });
};
//删除区域
export const deleteArea = id => {
    return request({
        url: `/eduRegion/delete/${id}`,
        method: 'post',
    });
};
//添加区域
export const addArea = params => {
    return request({
        url:'/eduRegion/add',
        method: 'post',
        data:params
    });
};
//修改区域
export const updateArea = params => {
    return request({
        url:'/eduRegion/update',
        method: 'post',
        data:params
    });
};
// 单位管理----------------------------------------
//单位管理列表
export const getUnitList = params => {
    return request({
        url: '/api/unit/getPageList',
        method: 'post',
        data:params
    });
};
//单位管理列表
export const getUnitList1 = params => {
    return request({
        url: '/api/unit/getPageList1',
        method: 'post',
        data:params
    });
};
//单位管理详情
export const getUnitDetail = id => {
    return request({
        url:`/eduUnit/info/${id}`,
        method: 'get',
    });
};
//单位管理详情
export const getUnitType = () => {
    return request({
        url:'/api/eduSubjectDeclare/getByType',
        method: 'post',
    });
};
//删除单位
export const deleteUnit = id => {
    return request({
        url: `/eduUnit/delete/${id}`,
        method: 'post',
    });
};
//添加单位
export const addUnit = params => {
    return request({
        url:'/eduUnit/add',
        method: 'post',
        data:params
    });
};
//修改单位
export const updateUnit = params => {
    return request({
        url:'/eduUnit/update',
        method: 'post',
        data:params
    });
};

// 用户管理---------------------------------
//获取角色列表
export const getRoleList = () => {
    return request({
        url:'/api/systemRole/getRoleList',
        method: 'post',
    });
};
//课题管理员页列表
export const getSubjectUserList = params => {
    return request({
        url: '/api/systemRole/getPageList',
        method: 'post',
        data:params
    });
};
//主管领导角色列表
export const getLeaderList = params => {
    return request({
        url: '/api/systemRole/getLeaderList',
        method: 'post',
        data:params
    });
};
//初审员角色页列表
export const getExaminerVoList = params => {
    return request({
        url: '/api/systemRole/getExaminerVoList',
        method: 'post',
        data:params
    });
};
//修改学段
export const updateLearningSection = params => {
    return request({
        url: '/api/eduLearningSection/updateRole',
        method: 'post',
        data:params
    });
};
//修改用户角色
export const updateRole = params => {
    return request({
        url: '/api/user/updateRole',
        method: 'post',
        data:params
    });
};
// 获取用户列表
export const getUserList = data => {
    return request({
        url:'/api/user/getPageList',
        method: 'post',
        data
    });
};
// 根据区域查询单位列表
export const getUnitListByArea = id => {
    return request({
        url:`/api/unit/getByRegionId/${id}`,
        method: 'post',
    });
};
// 添加用户
export const addUser = data => {
    return request({
        url:'/admin/systemUser/add',
        method: 'post',
				data
    });
};
// 删除用户
export const delUser = id => {
    return request({
        url:'/admin/systemUser/delete/' + id,
        method: 'post'
    });
};
// 修改用户
export const editUser = data => {
    return request({
        url:'/admin/systemUser/update',
        method: 'post',
        data
    });
};
// 获取用户详情
export const getUserDetail = id => {
    return request({
        url:`/admin/systemUser/info/${id}`,
        method: 'get',
    });
};

// 判断用户是否存在
export const userIsExists = userName => {
    return request({
        url:`/admin/systemUser/userIsExists/${userName}`,
        method: 'get',
    });
};



// 平台信息维护-------------------------------------------
// 获取平台信息维护列表
export const getPlatformInfoList = data => {
    return request({
        url:'/eduDictType/getPageList',
        method: 'post',
				data
    });
};


// 课题级别类别---------------------

// 获取平台信息数据
export const getPlatformInformationData = type => {
    return request({
        url:`/api/eduDictData/tree/${type}`,
        method: 'get',
    });
};
// 添加平台信息数据
export const addPlatformInformationData = data => {
    return request({
        url:'/eduDictData/add',
        method: 'post',
				data
    });
};
// 删除平台信息数据
export const delPlatformInformationData = id => {
    return request({
        url:'/eduDictData/delete/'+id,
        method: 'post'
    });
};
// 修改平台信息数据
export const editPlatformInformationData = data => {
    return request({
        url:'/eduDictData/update',
        method: 'post',
				data
    });
};

// 根据角色ID查询列表
export const getListByRoleId = data => {
    return request({
        url:'/api/user/getUserInfoByRoleId',
        method: 'post',
				data
    });
};
